import { makeAutoObservable } from 'mobx';

class TabStore {
  formData: any = {
    tab1Field: '',
    pendingTab: -1,
  };

  constructor() {
    makeAutoObservable(this);
  }
  updateField(name: string, value: any) {
    this.formData[name] = value;
  }
}

const tabStore = new TabStore();
export default tabStore;
